module.exports = __webpack_public_path__ + "img/gallery16.1e18ab4c.jpg";